import React from "react";
import CoderSchoolLogo from "./cs-logo.png";

export default ({ logo = true, course, description }) => (
  <div className="w-full" style={{ paddingLeft: "5vh", paddingRight: "5vh" }}>
    <div className="flex flex-col items-left">
      {logo ? (
        <img
          src={CoderSchoolLogo}
          style={{ width: "200px", height: "200px", objectFit: "contain" }}
        />
      ) : null}
      <h1>
        CoderSchool
        <br />
        <span className="text-link">{course}</span>
      </h1>
      <h4>{description}</h4>
    </div>
  </div>
);
